export default "__VITE_ASSET__DSyBJYMI__"